import { AbsoluteCenter } from '@chakra-ui/react';

import { Typography } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';

export const NextSessionErrorState = () => {
  return (
    <AbsoluteCenter>
      <Spacer size="zr zr md">
        <Spacer size="zr zr sm">
          <header>
            <Spacer size="zr zr md">
              <Typography as="div" type="largeHeading" textAlign="center">
                🙈
              </Typography>
            </Spacer>
            <Typography
              as="h1"
              type="heading"
              fontWeight="semibold"
              textAlign="center"
              color="black"
            >
              Something went wrong
            </Typography>
          </header>
        </Spacer>
      </Spacer>
    </AbsoluteCenter>
  );
};
